import React from "react";

export default function SQLServer_CONCAT_WS() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CONCAT_WS</h1>
      <p>This is the SQLServer_CONCAT_WS component generated from the SQL JSON.</p>
    </div>
  );
}
